import { render } from "./Message.view.vue?vue&type=template&id=35d3b891"
import script from "./Message.view.vue?vue&type=script&lang=js"
export * from "./Message.view.vue?vue&type=script&lang=js"

import "./Message.view.vue?vue&type=style&index=0&id=35d3b891&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__